import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import MerchantsTypes from '../types/MerchantsType';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  merchantsList: { ...initialStateList },
  allMerchants: [],
  countries: [],
  paymentMethods: [],
  details: {
    name: 'M',
  },
};

export const Merchants = handleActions(
  {
    ...GridFilters,
    [MerchantsTypes.actions.fetchMerchantSettingsFieldsData]: (state, { payload: { countries, paymentMethods = [] } }) => ({
      ...state,
      countries,
      paymentMethods,
    }),
    [MerchantsTypes.actions.fetchMerchantDetailsSuccess]: (state, { payload: { details } }) => ({
      ...state,
      details,
    }),
    [MerchantsTypes.actions.fetchMerchantsAllSuccess]: (currentState, { payload: { allMerchants } }) => ({ ...currentState, allMerchants }),
    [MerchantsTypes.actions.fetchCountriesCurrencyData]: (state, { payload: { countriesCurrency } }) => ({
      ...state,
      countriesCurrency,
    }),
    [MerchantsTypes.actions.fetchMerchantPossibleCurrencies]: (state, { payload: { currencies } }) => ({
      ...state,
      currencies,
    }),
  },
  initialState
);

const getMerchants = (state) => state.Merchants;

export const getMerchantsList = (state, list) => {
  const Merchants = getMerchants(state);
  return Merchants[list] || undefined;
};

export const getMerchantsCountries = createSelector(getMerchants, (state) => state.countries);

export const getMerchantsPaymentMethods = createSelector(getMerchants, (state) => state.paymentMethods);

export const getMerchantsAll = createSelector(getMerchants, (accounts) => accounts.allMerchants);

export const getMerchantDetails = createSelector(getMerchants, (state) => state.details);

export const getMerchantCountriesCurrency = createSelector(getMerchants, (state) => state.countriesCurrency);

export const getCurrencies = createSelector(getMerchants, (state) => state.currencies);
